export default "__VITE_ASSET__BfnHnR3y__"